import React, { Component } from 'react'
import SmallHeader from './SmallHeader'
import Footer from './Footer'

/**
 * Basic component that provides a standard template for non-specialized pages
 * e.g. those pages that are not part of the landing-elements
 */
export default class PageWrapper extends Component {
  /**
   * Render component
   */
  render () {
    const containerStyle = {
      width: '100%',
      minHeight: '100vh'
    }

    const bannerWrapper = {
      height: 'auto',
      width: '100%',
      backgroundColor: 'white',
      marginBottom: 28
    }

    const hrStyle = {
      display: 'block',
      position: 'relative',
      padding: 0,
      margin: '8px auto',
      height: 0,
      width: '100%',
      maxHeight: 0,
      fontSize: 1,
      lineHeight: 0,
      clear: 'both',
      border: 'none',
      borderTop: '1px solid #aaaaaa',
      borderBottom: '1px solid #ffffff'
    }

    return (
      <div style={containerStyle}>
        <div style={bannerWrapper}>
          <SmallHeader />
        </div>
        <hr style={hrStyle} />
        <hr style={hrStyle} />
        {this.props.children}
        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PageWrapper.js